import React from 'react';
import clsx from 'clsx';
import ErrorActiveCheckboxIcon from './svg/error-active-checkbox-sv.svg';

const ErrorActiveCheckBox = ({ children, onErrorCheckboxClick }) => (
    <div
        className={clsx('nui-check-button active cashin-closing-checkbox-notAvailable')}
        onClick={onErrorCheckboxClick}
    >
        <ErrorActiveCheckboxIcon />
        {children}
    </div>
);

export default ErrorActiveCheckBox;
